// NOTE: NSAI-6588 — the URL values each client's pages and settings screens
// read for their tabs, owned here so a deep link built on one platform (the
// global search index, a notification, a shared link) resolves on the other.
// They mirror web's enums value for value (pages/settings/types.ts,
// pages/analytics/types.ts, pages/agents/constants/tabs.ts,
// pages/integrations/types.ts, pages/knowledge/types.ts) and mobile's; the
// global-search-index test pins both so neither can drift silently.

export const SETTINGS_SECTION_VALUES = {
  PROFILE: "profile",
  ORGANIZATION: "organization",
} as const;

export const PROFILE_SETTINGS_TAB_VALUES = {
  GENERAL_INFORMATION: "generalInformation",
  BILLING: "billing",
  PREFERENCES: "preferences",
  MEMORY_INSTRUCTIONS: "memoryInstructions",
  MEMORY: "memory",
  CALENDAR: "calendar",
  API_KEYS: "apiKeys",
  BOT_SETTINGS: "botSettings",
  HISTORY: "history",
  TOKEN_USAGE: "tokenUsage",
  TOKEN_COST_USAGE: "tokenCostUsage",
  // NOTE: NSAI-5883 — mobile only: the server the app talks to and the way to
  // another one. Web is served by its server, so it has no such tab; the
  // global search entry carries PLATFORM_MOBILE.
  ABOUT: "about",
} as const;

// NOTE: BILLING is left out on purpose — web's EOrganizationTab.BILLING exists
// but its tab is commented out (NSAI-1677), so nothing can link to it.
export const ORGANIZATION_SETTINGS_TAB_VALUES = {
  GENERAL: "general",
  ROLES: "roles",
  PROJECTS: "projects",
  MODELS: "models",
  MEMBERS: "members",
  API_KEYS: "api_keys",
  SAML: "saml",
  INTEGRATION: "integration",
  CONNECTOR_APPROVAL: "connector_approval",
  CHAT_SETTINGS: "chat_settings",
  CALL_ASSISTANT: "call_assistant",
  SYNCATOR_API_KEYS: "syncator_api_keys",
  APPEARANCE: "appearance",
  HISTORY: "history",
  TOKEN_USAGE: "token_usage",
  TOKEN_COST_USAGE: "token_cost_usage",
  USAGE_LIMITS: "usage_limits",
  DATA_RETENTION: "data_retention",
  DOC_RECOGNITION: "doc_recognition",
  SIEM_EXPORT: "siem_export",
  MEMORY_POLICY: "memory_policy",
} as const;

export const ANALYTICS_TAB_VALUES = {
  DASHBOARD: "dashboard",
  MESSAGES: "messages",
  PROBES: "probes",
} as const;

export const AGENTS_TAB_VALUES = {
  SCHEDULED: "scheduled",
  WEBHOOKS: "webhooks",
  EVENT_RULES: "eventRules",
  MARKETPLACE: "marketplace",
} as const;

export const INTEGRATIONS_TAB_VALUES = {
  ALL: "all",
  CONNECTED: "connected",
  CUSTOM: "custom",
} as const;

export const KNOWLEDGE_TAB_VALUES = {
  MY_FILES: "my-files",
  SHARED_WITH_ME: "shared-with-me",
} as const;
